import { useState, type InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { Eye, EyeOff } from 'lucide-react'

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

/** Göz simgesiyle gösterilip gizlenebilen şifre alanı. */
export function PasswordInput({ className, ...rest }: Props): JSX.Element {
  const { t } = useTranslation('common')
  const [visible, setVisible] = useState(false)
  return (
    <div className="relative">
      <input {...rest} type={visible ? 'text' : 'password'} className={`input pr-10 ${className ?? ''}`} />
      <button
        type="button"
        tabIndex={-1}
        aria-label={visible ? t('passwordInput.hide') : t('passwordInput.show')}
        onClick={() => setVisible((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  )
}
